export default __webpack_public_path__ + "296791f075feba44581e36048848d62e.png";